export enum QueuePriorityEnum {
    LIFO="LIFO" ,
    FIFO="FIFO"
}